import { render, staticRenderFns } from "./MemberEducation.vue?vue&type=template&id=433f0fe0"
import script from "./MemberEducation.vue?vue&type=script&lang=js"
export * from "./MemberEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports